import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = new IntersectionObserver(([entry]) =>
    setIntersecting(entry.isIntersecting)
  );

  useEffect(() => {
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return isIntersecting;
}

function toTop () {
  window.scrollTo(0, 0)
}

function Navbar() {
  const navbar = useRef();
  window.onscroll = function () {
    navbar.current.classList.add('md:navbar')
    navbar.current.classList.add('md:hide-header')
  };
  // function to hide navbar on scroll and reurn to show on scroll up
  
  var prevScrollpos = window.scrollY;
  window.onscroll = function() {
    var currentScrollPos = window.scrollY;
    if (currentScrollPos === 0){
      navbar.current.classList.remove('lg:navbar')
      navbar.current.classList.remove('lg:hide-header')
      navbar.current.classList.remove('lg:show-header')
    }
    
    else if (prevScrollpos > currentScrollPos) {
      navbar.current.classList.remove('lg:hide-header')
      navbar.current.classList.add('lg:show-header')
    } else {
        navbar.current.classList.remove('lg:show-header')
        navbar.current.classList.add('lg:hide-header')
        navbar.current.classList.add('lg:navbar')
    }
    prevScrollpos = currentScrollPos;
  } 

  return (
    <nav
      ref={navbar}
      className="z-50 lg:hover:show-header h-[15%] w-full animate-transition"
    >
      <div className="nav-container flex lg:flex-row flex-col md:justify-end justify-start items-center bg-blue rounded-b-2xl h-full w-full border border-white ">
        <Link
          to="/"
          onClick={toTop}
          className="flex items-center p-[1%] box-border justify-evenly"
        >
          <img
            src={require("../assets/Logo.png")}
            alt="logo"
            className="md:w-[80px] md:h-[80px] w-[50px] h-[50px] ml-[2%]"
          />
          <h1 className="md:text-4xl text-xl text-white font-medium pl-[4%]">
            AutoJoomer
          </h1>
        </Link>
        <ul className=" flex-1 box-border w-full lg:text-right text-center md:text-2xl text-l font-sans text-white">
          <li className="inline-block pr-[2%]">
            <HashLink smooth to="/#features">
              Features
            </HashLink>
          </li>
          <li className="inline-block pr-[2%]">
            <HashLink smooth to="/#pricing">
              Pricing
            </HashLink>
          </li>
          <li className="inline-block pr-[2%]">
            <HashLink smooth to="/#faq">
              FAQ
            </HashLink>
          </li>
          <li className="inline-block pr-[2%]">
            <HashLink smooth to="/#about">
              About Us
            </HashLink>
          </li>
          <li className="inline-block pr-[2%]">
            <Link to="/download">Download</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
